import state from 'store';
import { Message, MessageFrom, MessageMethod } from 'types';
import { sendTracking } from '../client';
import { buildRequestContext } from '../client/helper';
import initParams from 'store/initParams';
import { triggerTrackEvent } from 'utils/events';
import { getRefChatQs, trackUpa } from './shared';
import { AxiosError } from 'axios';
import { getCookieValue } from './cookies';

interface TrackEvent {
  pageview_id: string;
  event_type: 'click' | 'show' | 'send' | 'system' | 'user';
  event_name: string;
  data?: Record<string, string | undefined>;
}

export type TrackEventWithoutPageview = Omit<TrackEvent, 'pageview_id'>;

export const trackEvent = (event: TrackEventWithoutPageview) => {
  const eventMerged = {
    ...event,
    data: {
      ...(event.data ?? {}),
      assistantId: initParams.assistantId,
      chatId: state.chatId,
      domain: initParams.domain,
      channel: initParams.channel,
      trackerId: getCookieValue('trackerid') ?? 'NOT_DEFINED',
      userId: state?.userInfo?.temporalUserId ?? 'undefined',
      url: window.location.href,
      ref: getRefChatQs(),
    },
  };

  return sendTracking(eventMerged, initParams.pageViewId, buildRequestContext(state, initParams))
    .then(response => {
      if (response.isRejected) {
        console.error(`Tracking error with body`, event, 'response: ', response);
        trackUpa(initParams.pageViewId, 'failed_chappie_tracking', 'isRejected=true');
      }
    })
    .catch((error: AxiosError) => {
      console.error(`Tracking error with body`, event, 'response: ', error);
      trackUpa(initParams.pageViewId, 'failed_chappie_tracking', error.message + ' - ' + error.code + ' - ' + error.name);
    });
};

export const trackNewMessage = (message: Message) => {
  triggerTrackEvent({
    event_type: 'user',
    event_name: 'message_sent',
  });

  if (message.from === 'USER') {
    const eventNameByMethod: { [key in MessageMethod]: string } = {
      TEXT: 'click_send_text',
      VOICE: 'click_send_record_message',
    };

    triggerTrackEvent({
      event_type: 'user',
      event_name: eventNameByMethod[message.method],
    });
  } else {
    const eventNameByFrom: { [key in Exclude<MessageFrom, 'USER'>]: string } = {
      BACKEND: 'auto_send_backend_message',
      FILTER: 'click_send_filter_message',
      SUGGESTION: 'click_send_suggestion_message',
      SYSTEM: 'auto_send_system_message',
    };

    triggerTrackEvent({
      event_type: 'user',
      event_name: eventNameByFrom[message.from],
      data: {
        message: message.text,
        actionId: message.action?.actionId || 'not_defined',
      },
    });
  }
};
